import { render, staticRenderFns } from "./historyMessage.vue?vue&type=template&id=28b4bf7b&scoped=true&"
import script from "./historyMessage.vue?vue&type=script&lang=js&"
export * from "./historyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4bf7b",
  null
  
)

export default component.exports